import { render, staticRenderFns } from "./admin-manageinbox.vue?vue&type=template&id=0538768d&"
import script from "./admin-manageinbox.vue?vue&type=script&lang=js&"
export * from "./admin-manageinbox.vue?vue&type=script&lang=js&"
import style0 from "./admin-manageinbox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports